import AxiosNode from '@/services/api/node/axios_node'

export default {
  checkNode: (data) => {
    return AxiosNode.put('/checknode', data)
  },
}
